import React from "react";
import { PageFooterHyperlink } from "./page-footer-hyperlink";

export const PageFooter = () => {
  return (
    <footer className="page-footer">
      <p className="page-footer__text">
        search powered by{" "}
        <PageFooterHyperlink path="https://www.algolia.com">
          algolia
        </PageFooterHyperlink>{" "}
        &mdash; scraping by{" "}
        <PageFooterHyperlink path="https://github.com/apmnt/postalservice">
          postal service
        </PageFooterHyperlink>{" "}
        &mdash; app by{" "}
        <PageFooterHyperlink path="https://aapomontin.com">
          aapo montin
        </PageFooterHyperlink>
      </p>
    </footer>
  );
};
